import React from 'react'
import Typography from 'aldoo-ra/Typography'
import Button from 'aldoo-ra/Button'
import Badge from 'aldoo-ra/Badge'
import Tooltip from 'aldoo-ra/Tooltip'
import {
  PlayIcon,
  PauseIcon,
  StopIcon,
  ArrowPathIcon,
  TrashIcon,
  CalendarIcon
} from '@heroicons/react/24/outline'

const ReleaseHeader = ({ release, loading, onStart, onPause, onResume, onStop, onDelete, onReschedule }) => {
  if (loading || !release) {
    return <Typography variant="admin_h3">Loading...</Typography>
  }

  const getStatusBadge = () => {
    const statusConfig = {
      scheduled: { label: 'Scheduled', variant: 'admin_info' },
      running: { label: 'Running', variant: 'admin_success' },
      paused: { label: 'Paused', variant: 'admin_warning' },
      completed: { label: 'Completed', variant: 'admin_success' },
      stopped: { label: 'Stopped', variant: 'admin_error' },
      failed: { label: 'Failed', variant: 'admin_error' }
    }

    const config = statusConfig[release.status] || { label: release.status, variant: 'admin_default' }

    // Show schedule time inline with badge for scheduled releases
    const badgeContent = release.status === 'scheduled' && release.scheduledAtFormatted
      ? `${config.label} · ${release.scheduledAtFormatted}`
      : config.label

    const badge = (
      <Badge variant={config.variant} size="large">
        {badgeContent}
      </Badge>
    )

    // Make badge clickable for scheduled releases
    if (release.status === 'scheduled') {
      return (
        <Tooltip text="Click to reschedule" position="bottom">
          <button
            onClick={onReschedule}
            className="cursor-pointer hover:opacity-80 transition-opacity"
          >
            {badge}
          </button>
        </Tooltip>
      )
    }

    return badge
  }

  const renderActions = () => {
    const actions = []

    if (release.status === 'scheduled') {
      actions.push(
        <Tooltip key="start" text="Start now" position="bottom">
          <Button variant="admin_icon" onClick={onStart}>
            <PlayIcon className="w-5 h-5 text-admin_success" />
          </Button>
        </Tooltip>
      )
    }

    if (release.status === 'running') {
      actions.push(
        <Tooltip key="pause" text="Pause" position="bottom">
          <Button variant="admin_icon" onClick={onPause}>
            <PauseIcon className="w-5 h-5 text-admin_warning" />
          </Button>
        </Tooltip>
      )
      actions.push(
        <Tooltip key="stop" text="Stop" position="bottom">
          <Button variant="admin_icon" onClick={onStop}>
            <StopIcon className="w-5 h-5 text-admin_error" />
          </Button>
        </Tooltip>
      )
    }

    if (release.status === 'paused') {
      actions.push(
        <Tooltip key="resume" text="Resume" position="bottom">
          <Button variant="admin_icon" onClick={onResume}>
            <PlayIcon className="w-5 h-5 text-admin_success" />
          </Button>
        </Tooltip>
      )
      actions.push(
        <Tooltip key="stop" text="Stop" position="bottom">
          <Button variant="admin_icon" onClick={onStop}>
            <StopIcon className="w-5 h-5 text-admin_error" />
          </Button>
        </Tooltip>
      )
    }

    if (['completed', 'stopped', 'failed'].includes(release.status)) {
      actions.push(
        <Tooltip key="delete" text="Delete release" position="bottom">
          <Button variant="admin_icon" onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-admin_error" />
          </Button>
        </Tooltip>
      )
    }

    if (['scheduled', 'failed'].includes(release.status)) {
      actions.push(
        <Tooltip key="delete" text="Delete release" position="bottom">
          <Button variant="admin_icon" onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-admin_error" />
          </Button>
        </Tooltip>
      )
    }

    return actions
  }

  return (
    <div className="flex items-center gap-2 mr-10">
      {getStatusBadge()}
      {renderActions()}
    </div>
  )
}

export default ReleaseHeader
